
interface DataEntity {
  Id: string;
  Value: number;
}

interface FloodStation {
  Code: string; // 站碼
  Name: string; // 站名
  Location: { Latitude: string; Longitude: string }; // 座標 lng, lat
  LocationStr: string;
  District: string; // 行政區
  FloodLevel: DataEntity;
  FloodLevelStr: string;
  FloodLevelHistoricalData: [{ Timestamp: string; Value: number }];
  Voltage: DataEntity;
  Signal: DataEntity;
  AlertThreshold: {
    Level1: number;
    Level2: number;
    Level3: number;
  };
  Elevation: string;
  Communication: string;
  Owner: string; //權責單位
  Timestamp: string; // ISO8601格式 2019-11-19T00:23:28+00:00
}

import Vue from "vue";
import axios from "axios";
import qs from "qs";
import moment from "moment";
const Loading = require("vue-loading-overlay");
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default Vue.extend({
  mounted() {
    this.login();
  },
  components: {
    Loading
  },
  data() {
    let fields = [
      {
        key: "Name",
        label: "站名",
        sortable: true
      },
      {
        key: "Code",
        label: "站碼",
        sortable: true
      },
      {
        key: "District",
        label: "行政區",
        sortable: true
      },
      {
        key: "LocationStr",
        label: "經緯度",
        sortable: true
      },
      {
        key: "FloodLevelStr",
        label: "淹水深度(cm)",
        sortable: true
      },
      {
        key: "Owner",
        label: "權責單位",
        sortable: true
      },
      {
        key: "Timestamp",
        label: "資料時間",
        sortable: true
      }
    ];
    return {
      isLoading: true,
      logined: false,
      stations: Array<FloodStation>(),
      fields
    };
  },
  methods: {
    login() {
      let param = {
        grant_type: "password",
        username: "yunlindemo",
        password: "123qwe"
      };

      return axios
        .post("/Portal/Token", qs.stringify(param))
        .then(res => {
          const ret = res.data;
          if (res.status === 200) {
            let bearerToken = `Bearer ${ret.access_token}`;
            axios.defaults.headers.common["Authorization"] = bearerToken;
            this.logined = true;
            this.fetchFloodStation();
          }
        })
        .catch(err => {});
    },
    fetchFloodStation(): any {
      return axios
        .get("/FloodManagement/Station/Flood")
        .then(res => {
          const payload: Array<FloodStation> = res && res.data;
          for (let st of payload) {
            st.Timestamp = moment(st.Timestamp)
              .local()
              .format("lll");
            st.LocationStr = `${st.Location.Latitude}, ${st.Location.Longitude}`;
            isNaN(st.FloodLevel.Value) ? st.FloodLevelStr = '數值錯誤' : st.FloodLevelStr = st.FloodLevel.Value.toFixed(1);
            this.stations.push(st);
          }
          this.isLoading = false;
        })
        .catch(err => alert(err));
    }
  }
});
